export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const WIPE_ALERT = "WIPE_ALERT";
export const ADD_FLAG = "ADD_FLAG";
export const REMOVE_FLAG = "REMOVE_FLAG";
export const ALERT_ERROR = "ALERT_ERROR";
